/* unplugin-vue-components disabled */import script from "./LoadingMask.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingMask.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingMask.vue?vue&type=style&index=0&id=65418dd6&lang=scss&scoped=true"
import "./LoadingMask.vue?vue&type=style&index=1&id=65418dd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65418dd6"]])

export default __exports__